import PropTypes from "prop-types"
import React from "react"
import { Button } from "reactstrap"

const ToggleSelectButton = ({
  active = false,
  onToggle,
  label,
  activeColor = "primary",
  inactiveColor = "outline-secondary",
  disabled = false,
  className = "",
}) => {
  return (
    <Button
      type="button"
      color={active ? activeColor : inactiveColor}
      disabled={disabled}
      className={`d-flex align-items-center gap-2 ${className}`}
      onClick={() => onToggle(!active)}
    >
      <i className={`bx ${active ? "bx-checkbox-checked" : "bx-checkbox"} fs-5`} />
      <span>{label}</span>
    </Button>
  )
}

ToggleSelectButton.propTypes = {
  active: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
  activeColor: PropTypes.string,
  inactiveColor: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default ToggleSelectButton
